import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "../common/icons";
import { BrandLogo } from "./StudentNav";
import { UserContext } from "../../context/UserContext";
import "./PageNotFound.css";

// F17: a cut-off email link used to land on a plain "404 Page Not Found". Now it has the
// student yellow look and a way on: Sign in (signed out) and Go to Anna. Staff addresses
// (/admin/..., or a signed-in staff member) point to the dashboard and the staff sign-in.

const hasToken = () => {
  try {
    return Boolean(localStorage.getItem("authToken"));
  } catch {
    return false;
  }
};

const PageNotFound = () => {
  const { pathname } = useLocation();
  const { user } = useContext(UserContext) || {};
  const signedIn = hasToken();
  const staff = pathname.startsWith("/admin") || Boolean(user && (user.is_staff || user.is_superuser));

  const home = staff ? (signedIn ? "/admin/dashboard" : "/admin/login") : "/";
  const signIn = staff ? "/admin/login" : "/?login=1";

  return (
    <div className={`nf-page${staff ? " is-staff" : ""}`}>
      <header className="nf-bar">
        <BrandLogo />
      </header>
      <main className="nf-main">
        <section className="nf-card" aria-labelledby="nf-title">
          <span className="nf-icon" aria-hidden="true">
            <Icon name="link" size={34} />
          </span>
          <h1 id="nf-title" className="nf-title">We can&rsquo;t find that page</h1>
          <p className="nf-text">
            {staff
              ? "The address may be cut off or out of date. Go back to the dashboard and open it from there."
              : signedIn
                ? "The link may be cut off. Open it again from your email, or go back to Anna."
                : "The link may be cut off. Open it again from your email, or sign in."}
          </p>
          <div className="nf-actions">
            {!signedIn && (
              <Link to={signIn} className="nf-btn is-primary">
                <Icon name="sign-in" size={20} />
                Sign in
              </Link>
            )}
            {/* A signed-out staff member's only way on is the staff sign-in */}
            {(!staff || signedIn) && (
              <Link to={home} className={`nf-btn ${signedIn ? "is-primary" : "is-ghost"}`}>
                <Icon name="home" size={20} />
                {staff ? "Go to the dashboard" : "Go to Anna"}
              </Link>
            )}
          </div>
          <p className="nf-code">Error 404</p>
        </section>
      </main>
    </div>
  );
};

export default PageNotFound;
